import React from 'react';

const PrivacyPolicy = () => {
  const currentDate = new Date().toLocaleDateString('ar-EG', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  const styles = {
    container: {
      maxWidth: '800px',
      margin: '0 auto',
      padding: '20px',
      backgroundColor: '#ffffff',
      fontFamily: 'Arial, sans-serif',
      lineHeight: '1.8',
      color: '#333',
      direction: 'rtl',
      textAlign: 'right'
    },
    header: {
      textAlign: 'center',
      marginBottom: '40px',
      borderBottom: '3px solid #28a745',
      paddingBottom: '20px'
    },
    title: {
      fontSize: '2.5rem',
      fontWeight: 'bold',
      color: '#2c3e50',
      marginBottom: '10px'
    },
    lastUpdated: {
      color: '#666',
      fontSize: '0.9rem',
      fontStyle: 'italic'
    },
    notice: {
      backgroundColor: '#e8f5e8',
      border: '1px solid #28a745',
      borderRight: '5px solid #28a745',
      padding: '20px',
      marginBottom: '30px',
      borderRadius: '5px'
    },
    noticeTitle: {
      fontWeight: 'bold',
      color: '#155724',
      marginBottom: '10px'
    },
    section: {
      marginBottom: '30px'
    },
    sectionTitle: {
      fontSize: '1.5rem',
      fontWeight: 'bold',
      color: '#2c3e50',
      marginBottom: '15px',
      borderBottom: '2px solid #ecf0f1',
      paddingBottom: '5px'
    },
    paragraph: {
      marginBottom: '15px',
      textAlign: 'justify'
    },
    list: {
      marginRight: '20px',
      marginBottom: '15px'
    },
    listItem: {
      marginBottom: '8px'
    },
    highlight: {
      backgroundColor: '#fff3cd',
      border: '1px solid #ffeaa7',
      padding: '15px',
      borderRadius: '5px',
      marginBottom: '15px'
    },
    goodNews: {
      backgroundColor: '#d4edda',
      border: '1px solid #c3e6cb',
      padding: '15px',
      borderRadius: '5px',
      marginBottom: '15px'
    },
    dataTable: {
      width: '100%',
      borderCollapse: 'collapse',
      marginBottom: '20px',
      border: '1px solid #dee2e6',
      direction: 'rtl'
    },
    tableHeader: {
      backgroundColor: '#f8f9fa',
      fontWeight: 'bold',
      padding: '12px',
      textAlign: 'right',
      borderBottom: '1px solid #dee2e6'
    },
    tableCell: {
      padding: '12px',
      borderBottom: '1px solid #dee2e6',
      textAlign: 'right'
    },
    contact: {
      backgroundColor: '#f8f9fa',
      border: '1px solid #dee2e6',
      padding: '20px',
      borderRadius: '5px',
      textAlign: 'center'
    },
    contactTitle: {
      fontWeight: 'bold',
      marginBottom: '10px',
      color: '#495057'
    },
    link: {
      color: '#007bff',
      textDecoration: 'none'
    },
    strong: {
      fontWeight: 'bold',
      color: '#2c3e50'
    }
  };

  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.header}>
        <h1 style={styles.title}>سياسة الخصوصية</h1>
        <div style={styles.lastUpdated}>
          آخر تحديث: {currentDate}
        </div>
      </div>

      {/* Important Notice */}
      <div style={styles.notice}>
        <div style={styles.noticeTitle}>تطبيق إخباري يحترم الخصوصية</div>
        <p>
          <span style={styles.strong}>الدار العراقية</span> مصمم لاحترام خصوصيتك. 
          هذا التطبيق للقراءة فقط ولا يتطلب معلومات شخصية أو إنشاء حساب.
        </p>
      </div>

      {/* Privacy Content */}
      <div>
        
        {/* Section 1 */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>1. المعلومات التي لا نجمعها</h2>
          <div style={styles.goodNews}>
            <p><span style={styles.strong}>أخبار جيدة! لا نجمع معظم أنواع المعلومات الشخصية:</span></p>
            <ul style={styles.list}>
              <li style={styles.listItem}>❌ لا نجمع أسماء أو عناوين بريد إلكتروني أو معلومات اتصال</li>
              <li style={styles.listItem}>❌ لا نتطلب حسابات مستخدمين أو تسجيل</li>
              <li style={styles.listItem}>❌ لا نجمع محتوى من المستخدمين (تعليقات، منشورات، إلخ)</li>
              <li style={styles.listItem}>❌ لا نتتبع الموقع</li>
              <li style={styles.listItem}>❌ لا نتكامل مع وسائل التواصل الاجتماعي</li>
              <li style={styles.listItem}>❌ لا نتتبع الإعلانات</li>
            </ul>
          </div>
        </div>

        {/* Section 2 */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>2. المعلومات المحدودة التي نجمعها</h2>
          <p style={styles.paragraph}>
            لتقديم خدمتنا الإخبارية، نجمع معلومات تقنية بسيطة:
          </p>
          
          <table style={styles.dataTable}>
            <thead>
              <tr>
                <th style={styles.tableHeader}>نوع البيانات</th>
                <th style={styles.tableHeader}>الغرض</th>
                <th style={styles.tableHeader}>مدة الاحتفاظ</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={styles.tableCell}>إحصائيات استخدام التطبيق</td>
                <td style={styles.tableCell}>تحسين أداء التطبيق</td>
                <td style={styles.tableCell}>30 يوماً</td>
              </tr>
              <tr>
                <td style={styles.tableCell}>نوع الجهاز</td>
                <td style={styles.tableCell}>ضمان توافق التطبيق</td>
                <td style={styles.tableCell}>غير مخزن</td>
              </tr>
              <tr>
                <td style={styles.tableCell}>أعطال التطبيق</td>
                <td style={styles.tableCell}>إصلاح المشاكل التقنية</td>
                <td style={styles.tableCell}>30 يوماً</td>
              </tr>
              <tr>
                <td style={styles.tableCell}>رمز الإشعارات (إذا مفعل)</td>
                <td style={styles.tableCell}>إرسال إشعارات الأخبار</td>
                <td style={styles.tableCell}>حتى إلغاء التثبيت</td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Section 3 */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>3. الإشعارات الفورية</h2>
          <p style={styles.paragraph}>
            إذا قمت بتفعيل الإشعارات الفورية للأخبار العاجلة:
          </p>
          <ul style={styles.list}>
            <li style={styles.listItem}>نحتفظ برمز الجهاز (غير مرتبط بهويتك)</li>
            <li style={styles.listItem}>يمكنك تعطيل الإشعارات في أي وقت من إعدادات جهازك</li>
            <li style={styles.listItem}>لا نتتبع ما إذا كنت تقرأ أو تضغط على الإشعارات</li>
            <li style={styles.listItem}>الإشعارات ترسل لجميع المستخدمين، وليست شخصية</li>
          </ul>
          <div style={styles.highlight}>
            <p><span style={styles.strong}>الإشعارات اختيارية تماماً</span> - التطبيق يعمل بكامل طاقته بدونها.</p>
          </div>
        </div>

        {/* Section 4 */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>4. خدمات الطرف الثالث</h2>
          <p style={styles.paragraph}>
            قد يستخدم تطبيقنا هذه الخدمات من طرف ثالث مع مشاركة بيانات محدودة:
          </p>
          <ul style={styles.list}>
            <li style={styles.listItem}><span style={styles.strong}>خدمة الإشعارات الفورية:</span> لتنبيهات الأخبار العاجلة (رمز الجهاز فقط)</li>
            <li style={styles.listItem}><span style={styles.strong}>إحصائيات متجر التطبيقات:</span> إحصائيات استخدام أساسية (مقدمة من آبل/جوجل)</li>
            <li style={styles.listItem}><span style={styles.strong}>تقارير الأعطال:</span> سجلات مجهولة للأعطال لإصلاح الأخطاء</li>
          </ul>
          <p style={styles.paragraph}>
            لا تتلقى أي من هذه الخدمات معلومات شخصية يمكن أن تحدد هويتك.
          </p>
        </div>

        {/* Section 5 */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>5. تخزين البيانات والأمان</h2>
          <div style={styles.goodNews}>
            <p><span style={styles.strong}>بيانات أقل = أمان أكثر:</span></p>
            <ul style={styles.list}>
              <li style={styles.listItem}>معظم بيانات التطبيق تُخزن محلياً على جهازك</li>
              <li style={styles.listItem}>المحتوى الإخباري يُحمل مؤقتاً</li>
              <li style={styles.listItem}>لا توجد ملفات شخصية أو قواعد بيانات</li>
              <li style={styles.listItem}>تشفير SSL لجميع عمليات نقل البيانات</li>
            </ul>
          </div>
        </div>

        {/* Section 6 */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>6. تحكمك في البيانات</h2>
          <p style={styles.paragraph}>
            نظراً لأننا نجمع بيانات محدودة، لديك هذه الخيارات:
          </p>
          <ul style={styles.list}>
            <li style={styles.listItem}><span style={styles.strong}>الإشعارات:</span> تفعيل/تعطيل من إعدادات الجهاز</li>
            <li style={styles.listItem}><span style={styles.strong}>بيانات التطبيق:</span> مسح بإلغاء تثبيت وإعادة تثبيت</li>
            <li style={styles.listItem}><span style={styles.strong}>التخزين المحلي:</span> يُمسح عند حذف التطبيق</li>
          </ul>
        </div>

        {/* Section 7 */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>7. خصوصية الأطفال</h2>
          <p style={styles.paragraph}>
            تطبيقنا آمن للمستخدمين من جميع الأعمار لأنه:
          </p>
          <ul style={styles.list}>
            <li style={styles.listItem}>لا يجمع معلومات شخصية</li>
            <li style={styles.listItem}>لا يحتوي على ميزات تفاعل المستخدمين</li>
            <li style={styles.listItem}>لا يحتوي على إعلانات أو تتبع</li>
            <li style={styles.listItem}>محتوى إخباري للقراءة فقط</li>
          </ul>
        </div>

        {/* Section 8 */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>8. المستخدمون الدوليون</h2>
          <p style={styles.paragraph}>
            ممارسات الخصوصية لدينا هي نفسها في جميع أنحاء العالم:
          </p>
          <ul style={styles.list}>
            <li style={styles.listItem}><span style={styles.strong}>GDPR (أوروبا):</span> متوافق بسبب جمع البيانات المحدود</li>
            <li style={styles.listItem}><span style={styles.strong}>CCPA (كاليفورنيا):</span> لا يتم بيع أو مشاركة معلومات شخصية</li>
            <li style={styles.listItem}><span style={styles.strong}>جميع المناطق:</span> نفس نهج الخصوصية أولاً</li>
          </ul>
        </div>

        {/* Section 9 */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>9. تغييرات سياسة الخصوصية</h2>
          <p style={styles.paragraph}>
            إذا قمنا بتغيير ممارسات الخصوصية لدينا:
          </p>
          <ul style={styles.list}>
            <li style={styles.listItem}>سنحدث هذه السياسة والتاريخ أعلاه</li>
            <li style={styles.listItem}>للتغييرات الكبيرة، سنُخطر المستخدمين عبر تحديث التطبيق</li>
            <li style={styles.listItem}>سنحتفظ دائماً بنهج الخصوصية أولاً</li>
          </ul>
        </div>

        {/* Section 10 */}
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>10. معلومات الاتصال</h2>
          <p style={styles.paragraph}>
            نظراً لأننا لا نجمع بيانات شخصية، فإن معظم أسئلة الخصوصية بسيطة الإجابة. 
            ومع ذلك، إذا كانت لديك أي مخاوف، يرجى الاتصال بنا:
          </p>
        </div>

        {/* Contact Section */}
        <div style={styles.contact}>
          <div style={styles.contactTitle}>أسئلة حول الخصوصية؟</div>
          <p>
            <span style={styles.strong}>البريد الإلكتروني:</span> <a href="mailto:Panoiq@gmail.com" style={styles.link}>Panoiq@gmail.com</a><br/>
            <span style={styles.strong}>العنوان: العراق بغداد الكرخ
كرادة مريم قرب جسر الجمهورية
الفرع المقابل لوزارة التخطيط</span> 
          </p>
          <div style={{marginTop: '15px', padding: '10px', backgroundColor: '#e8f5e8', borderRadius: '5px'}}>
            <p style={{margin: 0, fontSize: '0.9rem', color: '#155724'}}>
              <span style={styles.strong}>إجابة سريعة:</span> نظراً لأن تطبيقنا لا يجمع معلومات شخصية، 
              عادة لا يوجد شيء للحذف أو التصدير أو التعديل!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;